export enum rdeDevicegroupEnum {
    ATM = 1,
    PED = 2,
    POS = 3,
    'Cell Phone' = 4,
    'mini-ATM' = 5,
    SMSPrinter = 6
}

export namespace rdeDevicegroupEnum {
    export function values() {
        return Object.keys(rdeDevicegroupEnum).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }
}
